import { render } from "./AddressCorrection.vue?vue&type=template&id=1921a9ad&scoped=true"
import script from "./AddressCorrection.vue?vue&type=script&lang=js"
export * from "./AddressCorrection.vue?vue&type=script&lang=js"

import "./AddressCorrection.vue?vue&type=style&index=0&id=1921a9ad&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1921a9ad"]])

export default __exports__